/* eslint-disable no-plusplus */
export const setCookieCustom = (
 cname: string,
 cvalue: string,
 exminutes: number,
) => {
 const d = new Date();
 d.setTime(d.getTime() + exminutes * 60 * 1000);
 const expires = `expires=${d.toUTCString()}`;
 document.cookie = `${cname}=${cvalue};${expires};path=/;SameSite=Strict;Secure`;
};

export const getCookieCustom = (cname: string) => {
 const name = `${cname}=`;
 const decodedCookie = decodeURIComponent(document.cookie);
 const ca = decodedCookie.split(';');
 for (let i = 0; i < ca.length; i++) {
  let c = ca[i];
  while (c.charAt(0) === ' ') {
   c = c.substring(1);
  }
  if (c.indexOf(name) === 0) {
   return c.substring(name.length, c.length);
  }
 }
 return '';
};

export const deleteCookieCustom = (
 name: string,
 path: string,
 domain?: string,
) => {
 if (getCookieCustom(name)) {
  document.cookie = `${name}=${path ? `;path=${path}` : ''}${
   domain ? `;domain=${domain}` : ''
  };expires=Thu, 01 Jan 1970 00:00:01 GMT`;
 }
};
